import { isArray, toString } from 'lodash';

/**
 * @mergeFilter
 * @param array1
 * @param array2
 * @returns {*}
 */
export const mergeFilter = (array1, array2) => {
  if (isArray(array1) && isArray(array2)) {
    const countsMap = array2.reduce((acc, item) => {
      acc[item.id] = item.count;
      return acc;
    }, {});

    return array1
      .filter((item) => item.id !== null)
      .map((item) => ({
        ...item,
        count: countsMap[item.id] ?? 0,
      }));
  }
  return array1;
}

/**
 * @name getLastSubstr
 * @param number
 * @returns {string}
 */
export const getLastSubstr = (number) => toString(number).substr(toString(number).length - 3)
